import {
  ProductOptionsListContainer,
  ProductOptionsListRow,
  Label
} from './ProductOptionsList.styles'
import { IProductOptionsList } from './ProductOptionsList.types'

const ProductOptionsList = ({ bundlesExtra, subItem }: IProductOptionsList) => {
  const { items } = subItem
  const itemsSkus = Object.keys(items)
  const itemList = bundlesExtra.filter(({ sku }) => {
    const currentItem = itemsSkus.find(
      (currentSkuItem) => currentSkuItem === sku
    )
    return currentItem
  })
  const labels = itemList.map(({ name = '', sku = '' }) => (
    <ProductOptionsListRow key={`product-options-list-${name}`}>
      <Label>{`${items[sku]} ${name}`}</Label>
    </ProductOptionsListRow>
  ))
  return <ProductOptionsListContainer>{labels}</ProductOptionsListContainer>
}

export default ProductOptionsList
